type MembershipBody = Record<string, unknown>;

export interface MembershipMutationResult {
  message?: string;
  projectionStatus?: string;
  projection?: Record<string, { status?: string }>;
}

export async function postProjectMembershipV2(
  token: string,
  body: MembershipBody,
): Promise<MembershipMutationResult> {
  const response = await fetch('/api/admin/project-memberships/v2', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = (await response.json()) as MembershipMutationResult;
  if (!response.ok && response.status !== 207) {
    throw new Error(data.message || 'Failed to update project membership');
  }
  return data;
}

export async function deleteProjectMembershipV2(
  token: string,
  body: MembershipBody,
): Promise<void> {
  const response = await fetch('/api/admin/project-memberships/v2', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error((data as { message?: string }).message || 'Failed to remove project member');
  }
}
